import { render, staticRenderFns } from "./SmsEmailNotifications.vue?vue&type=template&id=2b5dd938&"
import script from "./SmsEmailNotifications.vue?vue&type=script&lang=js&"
export * from "./SmsEmailNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports